module.exports = __webpack_public_path__ + "img/3dview.2ce6f24c.svg";